import axiosClient from "@/service/client/AxiosClient";

export default {
    isAuthenticated: async () => {
        return axiosClient.get('/auth/isAuthenticated')
    },
    authenticate: async (payload) => {
        return axiosClient.post('/auth/authenticate', new URLSearchParams({
            u: payload.u,
            p: payload.p
        }))
    },
    selectUserForea: async (payload) => {
        return axiosClient.post('/auth/foreas', payload)
    },
    signOut: async () => {
        return axiosClient.post('/auth/signout')
    },

    /**
     * Gets all parametric.
     *
     * @param payload
     * @returns {Promise<AxiosResponse<any>|*>}
     */
    getCaptions: async () => axiosClient.get('/captions'),
}
